export const formatNumericPriceUSD = (input: number) => {
  return input.toLocaleString(undefined, { minimumFractionDigits: 2 });
};
